import { Controller } from '@hotwired/stimulus'

// Shows/hides an element, trigger by:
//
// a) Custom events
//
// Usage:
//   <div data-controller="show-element-on-event"
//     This will be shown when the event is received
//   </div>
//
// From another controller, dispatch the event:
//   this.dispatch("dispatched", { prefix: "custom-event" })
//
// b) Outlets

export default class extends Controller {
    show() {
        this.element.classList.remove('d-none')
    }

    hide() {
        this.element.classList.add('d-none')
    }

    toggle() {
        this.element.classList.toggle('d-none')
    }
}
